export default __webpack_public_path__ + "static/media/driver-1.98112538.svg";